<template>
  <div id="chat-layout" class="h-full">
    <div class="grid h-full m-0">
      <div id="col_menu" class="col-2 p-0 bg-primary m-0 flex flex-column justify-content-between">
        <PFMenu />
        <div v-if="customLogo" class="text-center	">
          <img :src="customLogo" width="130" />
        </div>
      </div>
      <div class="col-offset-2 col-10 p-0 content-wrapper">
        <PFHeader />
        
      <div class="content">
        <slot />
      </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { find } from 'lodash-es';

const {user} = useGeneralStore();

const { data: userData, signOut } = useAuth();
const { dynamicsSchema, dynamicFormSchema } = useSchema();
const tenant = useTenant();

const customLogo = computed(() => {
  if(!userData.value?.user) return null;
  const currentTenant = find((userData.value.user as any).tenantsData as any[], { name: tenant });
  return currentTenant?.custom_logo || null;
});

</script>
<style scoped lang="scss">
  .content {
    height: calc(100% - 60px);
  }
  .content-wrapper{
    max-height: 100%;
  }
</style>